import { render, staticRenderFns } from "./SendVideo.vue?vue&type=template&id=1db6c52d"
import script from "./SendVideo.vue?vue&type=script&lang=js"
export * from "./SendVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports